import { useStyletron } from '@thanx/uikit/theme'
import { GiftCard } from 'api/users'
import HeaderCell from 'components/HeaderCell'
import { buildTranslate } from 'locales'
import React from 'react'
import Row from './Row'

const t = buildTranslate('users.view.gift_cards')

type PropsT = {
  giftCards: Array<GiftCard>
}

const Table: React.FC<PropsT> = ({ giftCards }: PropsT) => {
  const [css] = useStyletron()

  return (
    <table
      className={`full-width ${css({
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
      })}`}
    >
      <thead>
        <tr>
          <HeaderCell className={`${css({ width: '25%' })}`}>
            {t('provider')}
          </HeaderCell>
          <HeaderCell className={`${css({ width: '25%' })} text-right`}>
            {t('last4')}
          </HeaderCell>
          <HeaderCell className={`${css({ width: '25%' })} text-right`}>
            {t('date_added')}
          </HeaderCell>
          <HeaderCell className={`${css({ width: '25%' })} text-right`}>
            {t('status')}
          </HeaderCell>
        </tr>
      </thead>
      <tbody>
        {giftCards.map(giftCard => (
          <Row key={`user_gift_cards_${giftCard.id}`} giftCard={giftCard} />
        ))}
      </tbody>
    </table>
  )
}

export default Table
